// import '@mdi/font/css/materialdesignicons.css'
import Vue from 'vue'
import Vuetify, { VSelect, VAutocomplete, VCombobox } from 'vuetify/lib'
import Ripple from 'vuetify/lib/directives/ripple'
// import 'vuetify/dist/vuetify.min.css'

import pt from 'vuetify/es5/locale/pt'

// Fix Vuetify 2.x leaveHandler race condition (Sentry AAWZ-WEB-3R9, AAWZ-WEB-3NP)
// VTooltip/VMenu/VHover/VRating inherit the Delayable mixin, which schedules a
// setTimeout('close') in leaveHandler. If the component is destroyed before the
// timer fires, Vue has already cleared $refs, so $refs.content.contains(...) throws.
// clearDelay() (clearTimeout on open/closeTimeout) cancels the pending timer in
// beforeDestroy — while $refs are still intact — preventing the crash.
//
// This is a GLOBAL mixin, so beforeDestroy runs on every component. To avoid ever
// calling an unrelated method that merely happens to be named "clearDelay", we
// require BOTH the clearDelay method AND the Delayable-exclusive timeout data keys.
// A component would have to fully reimplement Delayable to match — in which case
// cancelling its timers on destroy is exactly the desired behavior anyway.
export const vuetifyDelayableFix = {
  beforeDestroy() {
    const isDelayable =
      typeof this.clearDelay === 'function' &&
      this.$data &&
      ('openTimeout' in this.$data || 'closeTimeout' in this.$data)
    if (isDelayable) {
      this.clearDelay()
    }
  },
}

// Padrão global: menus de campos com seleção (select, autocomplete, combobox)
// abrem ABAIXO do campo (offsetY) em vez de cobri-lo. Evita repetir
// :menu-props="{ offsetY: true }" em cada uso.
function applyMenuOffsetY(component) {
  const props =
    (component.options && component.options.props) || component.props
  const menuProps = props && props.menuProps
  if (!menuProps || menuProps.offsetYPatched) {
    return
  }
  const originalDefault = menuProps.default
  menuProps.default = () => {
    const base =
      typeof originalDefault === 'function'
        ? originalDefault()
        : originalDefault
    return base && typeof base === 'object'
      ? { ...base, offsetY: true }
      : { offsetY: true }
  }
  menuProps.offsetYPatched = true
}

;[VSelect, VAutocomplete, VCombobox].forEach(applyMenuOffsetY)

Vue.mixin(vuetifyDelayableFix)

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
})
const opts = {
  icons: {
    iconfont: 'mdi',
    values: {
      sort: 'mdi-chevron-up',
    },
  },
  lang: {
    locales: { pt },
    current: 'pt',
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: '#56AF79',
        // secondary: '#C7BBC9',
        secondary: '#8E8E8E',
        accent: '#82B1FF',
        error: '#EB5757',
        info: '#2196F3',
        // Cores semanticas fixas no guia (claude design).
        success: '#398E4A', // antes #6FCF97
        warning: '#FF990A', // antes #FF6433
        danger: '#EB5757',
        purple: '#7000FF',
        muted: '#8E8E8E',
      },
    },
  },
}

export default new Vuetify(opts)
